<template>
  <div class="user_container">
    <div class="tabsContainer">
      <van-tabs v-model="active" color="#4EA27C" line-height="4px" line-width="20px">
        <van-tab name="用车详情" title="用车详情">
          <CarDetails />
        </van-tab>
        <van-tab name="费用详情" title="费用详情">
          <costDetail></costDetail>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import CarDetails from "../CarDetails/CarDetails.vue";
import costDetail from "../costDetail/index.vue";
// import predetermine from "../predetermine/predetermine";
export default {
  name: "applyDetail",
  props: {},
  components: {
    CarDetails,
    costDetail
    // predetermine
  },
  data() {
    return {
      active: "用车详情"
    };
  },
  created() { },
  mounted() { },
  methods: {
    tabClick() {
      console.log("active", this.active);
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}

.user_container {
  margin: auto;
  font-size: 14px;

  .tabsContainer {
    width: 100%;
    background-color: #fff;

    ::v-deep(.van-tabs__wrap) {
      width: 400px;
      height: 105px;
    }

    ::v-deep(.van-tab) {
      font-size: 29px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }

    ::v-deep(.van-tab--active) {
      font-size: 36px;
      font-family: PingFang-SC-Heavy, PingFang-SC;
      font-weight: 800;
      color: #282b32;
    }

    ::v-deep(.van-tabs__line) {
      border-radius: 0 !important;
    }
  }

  .flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .my-swipe {
    margin-bottom: 1vh;
  }

  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
  }

  .car-foot-nav {
    width: 40%;
    background: #fff;
    border-radius: 4px;
    margin: 2vh 0 0 0;
    padding: 2vh;
  }
}
</style>
